import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import {FaFileAlt, FaFileContract, FaKey} from 'react-icons/fa';
import './StaffMemberDashboard.css';
import ResetPasswordForm from "../component/ResetPasswordForm";
import {useDispatch, useSelector} from "react-redux";
import {getEmployeeRequest} from "../redux/actions/employeeActions";

const StaffMemberDashboard = () => {
    const dispatch = useDispatch();
    const email = useSelector(state => state.authentication.email);
    const employee = useSelector(state => state.employee.employee);
    const isLoadingGetEmployee = useSelector(state => state.employee.loading.getEmployee);
    const [showResetForm, setShowResetForm] = useState(false);

    useEffect(() => {
        if (!employee.ID && !isLoadingGetEmployee) {
            dispatch(getEmployeeRequest({email: email}));
        }
        if (employee.ID && employee.IsPasswordReset === 1) {
            setShowResetForm(false);
        }
    } , [dispatch, employee, email, isLoadingGetEmployee]);

    const resetPasswordForm = () => {
        setShowResetForm(false);
    }

    return (
        <>
            {!showResetForm && (
            <div className="dashboard-container">
                <h2 className="dashboard-title">Dashboard</h2>
                <div className="dashboard-links">
                    <Link to="/mdb/staff/contract" className="dashboard-link">
                        <FaFileAlt className="icon" />
                        <span>Persönliche Daten</span>
                    </Link>
                    <Link to="/mdb/staff/contracts" className="dashboard-link">
                        <FaFileContract className="icon" />
                        <span>Übersicht der Mitverwendungen</span>
                    </Link>
                    <a onClick={() => setShowResetForm(1)} className="dashboard-link">
                        <FaKey className="icon"/>
                        <span>Passwort zurücksetzen</span>
                    </a>
                </div>
            </div>
            )}
            {showResetForm && (
                <div className="dashboard-container">
                    <h2 className="dashboard-title">Passwort resetten</h2>
                    <div className="row header-row d-none d-md-flex">
                        <div className="col">
                            <ResetPasswordForm previousStep={resetPasswordForm} showPassword="1" emailAddress={email}/>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default StaffMemberDashboard;
